import { useAuth } from "@/contexts/AuthContext";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

/**
 * Restringe uma rota a administradores. Assume-se dentro de <ProtectedRoute>
 * (sessão já resolvida); quem não for admin é redirecionado à raiz.
 */
export function AdminRoute({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (user?.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
